// extracted by mini-css-extract-plugin
module.exports = {"MetricDisplay":"MetricDisplay_MetricDisplay__RrySm","Label":"MetricDisplay_Label__FurUp","Value":"MetricDisplay_Value__0dUVC","Icon":"MetricDisplay_Icon__q4UyA"};